import { useState, useEffect } from 'react';
import { getThemeClasses } from '../constants/theme';

export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Dynamic favicon based on theme — removed, using static profile photo instead

  const theme = getThemeClasses(isDarkMode, scrolled);
  const toggleDarkMode = () => setIsDarkMode(prev => !prev);

  return {
    isDarkMode,
    scrolled,
    theme,
    toggleDarkMode
  };
};